import { useEffect } from 'react';
import { getDefaultStore } from 'jotai';
import { WS_EVENTS } from '@twinden/shared';
import { updateFamilyAtom, type FamilyListItem } from '../store';
import { useWebSocket } from './useWebSocket';

type Store = ReturnType<typeof getDefaultStore>;

/**
 * A root renamed the family or changed its handle (M59, D216): every
 * member's switcher and Manage family show it without a reload.
 */
export function applyFamilyUpdated(payload: unknown, store: Store) {
  const { familyId, name, handle } = (payload ?? {}) as {
    familyId?: unknown;
    name?: unknown;
    handle?: unknown;
  };
  if (typeof familyId !== 'string') return;
  const updates: Partial<FamilyListItem> = {};
  if (typeof name === 'string') updates.name = name;
  if (typeof handle === 'string') updates.handle = handle;
  if (Object.keys(updates).length === 0) return;
  store.set(updateFamilyAtom, { id: familyId, updates });
}

/** Mounted once, in the app shell. */
export function useFamilyUpdated() {
  const { onEvent } = useWebSocket();
  useEffect(
    () =>
      onEvent(({ event, payload }) => {
        if (event === WS_EVENTS.FAMILY_UPDATED)
          applyFamilyUpdated(payload, getDefaultStore());
      }),
    [onEvent]
  );
}
